import { ForwardRefExoticComponent, RefAttributes } from 'react';

import { Icon, IconMoodSad, IconProps } from '@tabler/icons-react';

import { Card } from '..';

interface EmptyStateProps {
  icon?: ForwardRefExoticComponent<IconProps & RefAttributes<Icon>>;
  contentName: string;
}

export function EmptyState({ icon: IconComponent, contentName }: EmptyStateProps) {
  return (
    <Card
      icon={{
        svg: IconComponent ? <IconComponent stroke={1.5} size={64} /> : <IconMoodSad stroke={1.5} size={64} />,
      }}
      contentAlignment={{ alignment: { horizontalAlignment: 'center' } }}
      layout="dialog"
      title={`No ${contentName} available.`}
      description="Please try again later."
    />
  );
}
